export default __webpack_public_path__ + "static/media/3242a253778b9f7463432803084c0f23.svg";